import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';
import { map, Observable, startWith } from 'rxjs';
import { AuthService } from 'src/app/services/common/auth.service';
import { HealthAppService } from 'src/app/services/explore-health/health-app.service';

@Component({
  selector: 'app-select-organization-dialog',
  templateUrl: './select-organization-dialog.component.html',
  styleUrl: './select-organization-dialog.component.scss',
})
export class SelectOrganizationDialogComponent {
  public organizations: any[] = [];
  public filteredOrganizations!: Observable<any[]>;
  orgId: number = 0;
  orgCtrl: FormControl = new FormControl('');

  constructor(
    public dialogRef: MatDialogRef<SelectOrganizationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public tenants: any,
    private readonly haService: HealthAppService,
    private readonly auth: AuthService
  ) {}

  ngOnInit(): void {
    if (this.tenants) {
      this.setOrganizations(cloneDeep(this.tenants ?? []));
    } else {
      this.haService.getOrganizations().subscribe((response: any) => {
        this.setOrganizations(response ?? []);
      });
    }
  }

  setOrganizations(tenants: any) {
    this.organizations = tenants?.length ? tenants : [];
    this.filteredOrganizations = this.orgCtrl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterOrganizations(value))
    );
  }

  private _filterOrganizations(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.organizations.filter((org) =>
      org.orgName.toLowerCase().startsWith(filterValue)
    );
  }
  onSubmit() {
    let org = this.organizations?.find((it: any) => it.orgId == this.orgId);
    if (org) {
      this.auth.setOrgStore(org);
    } else if (this.orgId != 0) {
      this.auth.setOrgStore({
        orgId: this.orgId,
      });
    } else {
      return;
    }

    this.dialogRef.close({
      success: true,
      tenants: this.organizations,
    });
  }

  close() {
    this.dialogRef.close();
  }
}
